/* eslint-disable import/no-cycle */
import React, { useState } from 'react';
import { Button } from '@components';
import { useNavigate } from 'react-router-dom';
import { multipleFormatString } from '../../../common/utils/formatString';
import { MEUS_DADOS } from '../../../common/utils/paths';
import { ConfiguracaoPortalService } from '../../../common/services/configuracaoPortal';

export const AtualizacaoCadastral = ({ user, setPendenciaAtiva }) => {
  const confPortalService = new ConfiguracaoPortalService();
  const navigate = useNavigate();
  const {
    celular,
    telefone,
    email,
    cidade,
    bairro,
    complemento,
    numero,
    logradouro,
  } = user.dadosPessoais;
  const [loading, setLoading] = useState(false);

  const CELULAR_TELEFONE =
    celular + (celular && telefone && ` | `) + telefone || 'Não informado';

  const EMAIL = email.toLowerCase() || 'Não informado';

  const ENDERECO_COMPLETO = `
      ${
        logradouro
          ? multipleFormatString(`${logradouro} ${numero}`)
          : 'Não informado'
      }
      ${complemento ? multipleFormatString(` - ${complemento}`) : ''}
      ${bairro ? multipleFormatString(`, ${bairro} - ${cidade}`) : ''}
    `;

  return (
    <div>
      <p className="ts-24 mb-2 fw-bold text-orange">
        CONFIRMAÇÃO DOS DADOS CADASTRAIS
      </p>
      <h1 className="ts-20 fw-bold mb-2">Seus dados estão corretos?</h1>
      <p className="ts-16 text-muted mb-md-4">
        Certifique-se de que seus dados de contato e endereço estão devidamente
        atualizados. Se necessário, acesse a seção <b>Meus Dados</b> para
        solicitar a atualização.
      </p>
      <p className="fw-bold text-orange ts-16">Email</p>
      <p className="fw-bold text-muted ts-16">{EMAIL}</p>
      <p className="fw-bold text-orange ts-16 mt-3">Celular / Telefone</p>
      <p className="fw-bold text-muted ts-16">{CELULAR_TELEFONE}</p>
      <p className="fw-bold text-orange ts-16 mt-3">Endereço</p>
      <p className="fw-bold text-muted ts-16">{ENDERECO_COMPLETO}</p>

      <div className="row mt-md-4">
        <div className="col-md-6">
          <Button
            onClick={() => {
              navigate(MEUS_DADOS);
            }}
            transparent
            color="orange"
          >
            Ir para Meus Dados
          </Button>
        </div>
        <div className="col-md-6">
          <Button
            disabled={loading}
            onClick={() => {
              setLoading(true);
              confPortalService
                .RegistrarConfirmacaoCadastroAtualizado(
                  user.matricula,
                  user.dadosPessoais.cpf,
                  user.token
                )
                .then(() => {
                  setPendenciaAtiva('');
                  setLoading(false);
                });
            }}
          >
            {!loading ? 'Sim, estão corretos' : 'Carregando...'}
          </Button>
        </div>
      </div>
    </div>
  );
};
